<p-dropdown (onChange)='onChange($event.value)' [ngModel]='selectedEngine' [options]='engines'>
</p-dropdown>

<span class="warning-partner" *ngIf="(selectedEngine) === 'Marketplace'">This view is deprecated, the price won't be up to date, please use our new <a [href]="frontUrl" target="_blank" rel="noopener noreferrer"><b>front</b></a> </span>